// Mascara viva de CPF (###.###.###-##): formata enquanto o usuario digita, tolerante a
// paste (o evento `input` cobre colar) e a valores ja formatados. Apresentacao apenas —
// o server normaliza qualquer formato (Synexis::Cpf.digits) e valida o digito verificador,
// entao aqui NAO ha validacao, so formatacao progressiva com preservacao do caret.
export default class extends HTMLElement {
  connectedCallback () {
    if (!this.input) return

    this.input.maxLength = 14
    this.format()
    this.input.addEventListener('input', this.onInput)
  }

  disconnectedCallback () {
    // O restore do cache do Turbo re-conecta o element: sem o unbind acumulariamos
    // listeners duplicados no mesmo input.
    this.input?.removeEventListener('input', this.onInput)
  }

  get input () {
    return this.querySelector('input')
  }

  onInput = () => this.format(true)

  format (withCaret = false) {
    const input = this.input
    const digitsBeforeCaret = withCaret
      ? (input.value.slice(0, input.selectionStart ?? input.value.length).match(/\d/g) || []).length
      : null

    const digits = (input.value.match(/\d/g) || []).join('').slice(0, 11)

    let formatted = digits
    if (digits.length > 9) {
      formatted = `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`
    } else if (digits.length > 6) {
      formatted = `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`
    } else if (digits.length > 3) {
      formatted = `${digits.slice(0, 3)}.${digits.slice(3)}`
    }

    if (input.value === formatted) return

    input.value = formatted

    // Reposiciona o caret apos o N-esimo digito: sem isto, editar no meio do valor
    // jogaria o cursor para o fim a cada tecla.
    if (digitsBeforeCaret !== null && document.activeElement === input) {
      let pos = 0
      let seen = 0

      while (pos < formatted.length && seen < digitsBeforeCaret) {
        if (/\d/.test(formatted[pos])) seen += 1

        pos += 1
      }

      input.setSelectionRange(pos, pos)
    }
  }
}
